<app-time-slots-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-time-slots-filters>

<div class="table-container">
   <table mat-table matSort [dataSource]="timeslots" multiTemplateDataRows matSortDisableClear matSortDirection="asc">

        <ng-container matColumnDef="start_time">
            <th mat-header-cell *matHeaderCellDef> Orario di inizio </th>
            <td mat-cell *matCellDef="let element"> {{ element.start_time }} </td>
        </ng-container>

        <ng-container matColumnDef="end_time">
            <th mat-header-cell *matHeaderCellDef> Orario di fine </th>
            <td mat-cell *matCellDef="let element"> {{ element.end_time }} </td>
        </ng-container>

        <ng-container matColumnDef="day_of_week">
            <th mat-header-cell *matHeaderCellDef> Giorno della settimana </th>
            <td mat-cell *matCellDef="let element"> {{ getDayLabel(element.day_of_week) }} </td>
        </ng-container>

        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef> Attivo </th>
            <td mat-cell *matCellDef="let element"> {{ element?.active === true ? 'Si' : 'No' }} </td>
        </ng-container>

        <!-- <ng-container matColumnDef="tenant_id">
            <th mat-header-cell *matHeaderCellDef> Punto Vendita </th>
            <td mat-cell *matCellDef="let element"> {{ element.tenant_id }} </td>
        </ng-container> -->

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="add-icon-container">
              <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo orario di apertura"
                (click)="$event.stopPropagation(); addTimeSlot()" color="primary">
                <mat-icon>add</mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let row" class="modify-icon-container">
              <ng-container>
                <button mat-icon-button (click)="$event.stopPropagation(); editTimeSlot(row)">
                  <mat-icon matTooltip="Modifica">create</mat-icon>
                </button>
              </ng-container>
              <!-- <button mat-icon-button (click)="$event.stopPropagation(); deleteTimeSlot(row)">
                <mat-icon matTooltip="Elimina">delete</mat-icon>
              </button> -->
            </td>

          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editTimeSlot(row)"></tr>
   </table>

   <mat-paginator     [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSizeOptions[0]"
  [length]="total | async">
  </mat-paginator>

</div>